import { css } from '@app/styled';
import { zIndex } from '@app/theme';

// This one extracted from the Tutorial component for now.
// It will be deleted on the next migration because this globalStyles folder
// related to other Providers, which leads to hundreds of files changed.
export const wistiaOverrideStyles = css`
    .wistia_popover_overlay {
        z-index: ${zIndex('wistiaPopoverOverlay')} !important; // Overriding inline styles so !important is necessary
    }
    .wistia_popover_embed {
        z-index: ${zIndex('wistiaPopoverEmbed')} !important; // Overriding inline styles so !important is necessary
    }
`;
